
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 5.8H2c-.4 0-.8.3-.8.8v19.6c0 .4.3.8.8.8h18.4l7.3 5.9V27H32c.4 0 .8-.3.8-.8V6.5c0-.4-.4-.7-.8-.7v0z","stroke":"#47AEA6","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.1 18.1a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zm-6 .1a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zm12 0a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z","fill":"#F9A91E"}})])
          )
        }
      }
    